import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const SidebarHide20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M18.0303 9.96968L16.9697 11.0303L12.9393 7.00001L16.9697 2.96968L18.0303 4.03034L15.0607 7.00001L18.0303 9.96968Z'
      fill='currentColor'
    />
    <path d='M1 4.75001H11V3.25001H1V4.75001Z' fill='currentColor' />
    <path d='M1 10.75H11V9.25001H1V10.75Z' fill='currentColor' />
    <path d='M19 16.75H1V15.25H19V16.75Z' fill='currentColor' />
  </Svg>
);

SidebarHide20.displayName = 'SidebarHide20';
export default SidebarHide20;
